module.exports = __webpack_public_path__ + "static/media/Whole Life Brochure.689412c9.pdf";